export default __webpack_public_path__ + "static/logo_puzzle@big-666c91b5a98949e28a4fac0a53dcc161.png";